import { createAction } from '@reduxjs/toolkit';
export const openCreateCustomerAgentActionWizardAction = createAction('forms-ai-lib/openCreateCustomerAgentActionWizard', formId => ({
  payload: formId
}));
export const closeCreateCustomerAgentActionWizardAction = createAction('forms-ai-lib/closeCreateCustomerAgentActionWizard');